<ng-container *ngIf="!isLoading else loadingView">
    <form [formGroup]="addForm" (ngSubmit)="onSubmit()">
        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="col-md-12">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Functional Type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                            formControlName="functionalType"
                            [options]="functionalTypes"
                            optionLabel="name"
                            placeholder="Select Type"
                            scrollHeight="200px"
                    >
                    </p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Property Type</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                            formControlName="functionalName"
                            [options]="functionalNames"
                            optionLabel="name"
                            placeholder="Select Type"
                            scrollHeight="200px"
                            (onChange)="checkFunction()"
                    >
                    </p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper *ngIf="userDefined">
                <acabim-form-input-label>User-Defined</acabim-form-input-label>
                <acabim-form-input-content>
                    <input formControlName="userDefined">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Property Value</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <div>
                        <input formControlName="propertyValue">
                        <span class="cas-form-units">$</span>
                    </div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Remarks</acabim-form-input-label>
                <acabim-form-input-content>
                    <input formControlName="remarks">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>

        <div class="cas-action-buttons">
            <button class="cas-button-action">OK</button>
        </div>
    </form>
</ng-container>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
